<template>
  <div class="form-group position-relative">
    <label class="form-label"
           :class="labelclass"
           v-if="showlabel"
           :data-content="label">
      <span class="">{{ label }}</span>
      <span v-if="required"> *</span>
    </label>
    <jodit-editor v-model="tmpValue"
                  ref="autotext"
                  :buttons="joditConfig.buttons"
                  :config="finalConfig"/>
    <ValidationError class="mt-1"
                     v-if="showErrors"
                     :validationId="validationId"/>
  </div>
</template>

<script setup>
import ValidationError from "@/components/form/ValidationError.vue"
import { JoditEditor } from 'jodit-vue'
import { joditConfig } from "@/dictionaries/joditConfig"
import {computed, onBeforeMount, ref, watch} from "vue"
import {copyObject} from "@/extensions/prototypes/prototypes"

const emit = defineEmits(['input'])

const tmpValue = ref('')
const autotext = ref(null)

const props = defineProps({
  value: {
    type: Boolean,
    default: false
  },
  labelclass: { default: ''},
  showlabel: {
    type: Boolean,
    default: true
  },
  label: {},
  required: {
    type: Boolean,
    default: false
  },
  showErrors: {
    type: Boolean,
    default: false
  },
  validationId: {},
})

onBeforeMount(() => {
  JoditEditor.compatConfig = {MODE: 3}
  let val = (props.value || '').toString()
  if(val === 'true' || val === 'false') val = ''
  tmpValue.value = val
})

const finalConfig = computed(() => {
  return copyObject(joditConfig.config)
  // opts.events = {
  //   afterEnterFullSize: () => {
  //     console.log('afterEnterFullSize')
  //     // isEditorFullscreen.value = true
  //   },
  //   afterExitFullSize: () => {
  //     console.log('afterExitFullSize')
  //     // isEditorFullscreen.value = false
  //   }
  // }
  // return opts
})

watch(tmpValue, (val) => {
  emit('input', val)
})

const focusCustom = () => {
  autotext.value?.editor?.focus()
}

defineExpose({
  focusCustom,
})
</script>
